import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
require('./BoxOptionsContainer.scss');

const classNames = require('classnames');

const THEME1 = 'theme1';
const THEME2 = 'theme2';
const THEME3 = 'theme3';
class BoxOptionsContainer extends PureComponent {
    constructor(props) {
        super(props);
    }

    buildTag() {
        const { disabled, tag } = this.props;
        const tagClass = classNames('open-bo-container__tag-title', {
            'open-bo-container__tag-title--disabled': disabled,
        });
        return (
            <div className={tagClass}>
                <div className={'open-bo-container__tag-container'}>
                    <div className={'open-bo-container__tag-triangle'} />
                    <div className={'open-bo-container__tag-text'}>{tag}</div>
                </div>
            </div>
        );
    }

    buildImg() {
        const { img } = this.props;
        return (
            !!img && (
                <div className={'open-bo-container__img'}>
                    <img alt="icon" src={img} />
                </div>
            )
        );
    }

    buildTitle() {
        const { title, abbrTitle } = this.props;
        return (
            <>
                <div className="open-identification__title--minimize">{abbrTitle}</div>
                <div className={'open-bo-container__title'}>{title}</div>
            </>
        );
    }

    buildContent() {
        const { content, selected, disabled } = this.props;

        const contentClass = classNames('open-bo-container__content', {
            'open-bo-container__content--selected': selected,
            'open-bo-container__content--disabled': disabled,
        });
        return (
            !!content && (
                <div
                    className={contentClass}
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML={{ __html: content }}
                />
            )
        );
    }

    getTheme = theme => {
        switch (theme) {
            case '2':
                return THEME2;
            case '3':
                return THEME3;
            case '1':
            default:
                return THEME1;
        }
    };

    render() {
        const { disabled, onClick, selected, tag, boxCustomClass, partner } = this.props;

        const boxClass = classNames('open-bo-container', {
            'open-bo-container--selected': selected,
            'open-bo-container--disabled': !selected && disabled,
            [boxCustomClass]: boxCustomClass,
        });

        const theme = partner && this.getTheme(this.props.partner.get('theme'));

        return (
            <div className={`open-identification ${theme}`}>
                {tag && <div className="open-identification__tag--minimize">{tag}</div>}
                <div onClick={onClick} className={boxClass}>
                    {tag && this.buildTag()}
                    <div className={'open-bo-content'}>
                        {this.buildImg()}
                        {this.buildTitle()}
                        {this.buildContent()}
                    </div>
                </div>
            </div>
        );
    }
}

BoxOptionsContainer.propTypes = {
    disabled: PropTypes.bool.isRequired,
    tag: PropTypes.node,
    content: PropTypes.node,
    title: PropTypes.node,
    abbrTitle: PropTypes.node,
    img: PropTypes.node,
    onClick: PropTypes.func,
    boxCustomClass: PropTypes.string,
};

BoxOptionsContainer.defaultProps = {
    disabled: false,
    tag: undefined,
    content: undefined,
    title: undefined,
    img: undefined,
    onClick: undefined,
};

export default connect(state => ({
    partner: state.products.get('partner'),
}))(BoxOptionsContainer);
